var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralnsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4001 0H9.59999C3.472 0 0 3.472 0 9.59999V26.4001C0 32.512 3.456 36 9.59999 36H26.4001C32.528 36 36 32.512 36 26.4001V9.59999C36 3.472 32.528 0 26.4001 0Z",
    fill: "#FFF1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2112 9.57697L18.5816 8.07509C18.1865 7.97497 17.6927 7.97497 17.3964 8.07509L11.7668 9.57697C10.1865 9.97747 9.1001 11.3792 9.1001 12.8811V16.1852C9.1001 16.786 9.1001 17.4869 9.19886 18.0876C9.49516 19.7897 10.0878 21.3917 11.0754 22.8936C11.8655 24.0951 12.7544 25.0964 13.8408 25.8974L15.026 26.9987C15.9149 27.6996 16.9026 28 17.989 28C19.0754 28 20.0631 27.6996 20.952 26.9987L22.1371 26.0976C25.1989 23.5945 26.8779 20.0901 26.8779 16.2854V12.8811C26.8779 11.3792 25.7915 9.97747 24.2112 9.57697Z",
    fill: "#FB9E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 16L17.0479 19.8889L15.0446 17.9445",
    stroke: "#FFF1E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralnsurance);
export default __webpack_public_path__ + "static/media/Generalnsurance.f1c594b9c0d79d8f6665337b2c63ebee.svg";
export { ForwardRef as ReactComponent };